'use client';
import Image from 'next/image';

const speakers = [
  {
      name: "Atul Yadav",
      designation: "Co-founder",
      company: "Outspark",
      imageSrc: "/images/speakers/atul-yadav.webp",
      alt: "atul-yadav",
    },
    {
      name: "Pekka Kelkka",
      designation: "Cheif Academic Advisor",
      company: "LBank Labs",
      imageSrc: "/images/speakers/pekka-kelkka.webp",
      alt: "pekka-kelkka",
    },
    {
      name: "Praveen Dilliwala",
      designation: "Founder & Content creator",
      company: "Socialsky Media",
      imageSrc: "/images/speakers/praveen-dilliwala.webp",
      alt: "praveen-dilliwala",
    },
    {
      name: "Lara Varlamova",
      designation: "CEO",
      company: "Vision Voices Podcast",
      imageSrc: "/images/speakers/lara-varlamova.webp",
      alt: "lara-varlamova",
    },
  // end of past speaker 2025
  {
    name: "Constantin Kogan",
    designation: "CEO",
    company: "TDX",
    imageSrc: "/images/speakers/constantin-kogan.webp",
    alt: "Constantin",
  },
  {
    name: "EvanLuthra",
    designation: "General Partner",
    company: "KOL Capital",
    imageSrc: "/images/speakers/evan-luthra.webp",
    alt: "EvanLuthra",
  },
  {
    name: "Antoine",
    designation: "CEO",
    company: " StlakChain / StalkFun",
    imageSrc: "/images/speakers/antoine-rousseaux.webp",
    alt: "AntoineRousseaux",
  },
  {
    name: "Alexander Belov",
    designation: "Forbes journalist",
    company: "Coinstelegram Media & Fund ",
    imageSrc: "/images/speakers/alexander-belov.webp",
    alt: "AlexanderBelov",
  },
  
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:67:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="67" data-component-end-line="105" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20px-4%20py-6%20flex%20flex-col%20items-center%20justify-center%20bg-white%22%7D"
      id="speakers"
      className="w-full px-4 py-6 flex flex-col items-center justify-center bg-white"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:71:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="71" data-component-end-line="104" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1270px%5D%22%7D" className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.jsx:73:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="73" data-component-end-line="75" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22mb-10%20text-2xl%20sm%3Atext-3xl%20md%3Atext-3xl%20text-center%20lg%3Atext-%5B48px%5D%20font-bold%20leading-tight%20lg%3Aleading-%5B56px%5D%20text-%5B%230F0F0F%5D%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="mb-10 text-2xl sm:text-3xl md:text-3xl text-center lg:text-[48px] font-bold leading-tight lg:leading-[56px] text-[#0F0F0F]">
          Past Speakers
        </h2>

        {/* Speaker Grid */}
        <div data-component-id="src/app/SpeakerSection.jsx:78:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="78" data-component-end-line="103" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-8%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 place-items-center">
          {speakers.map((speaker, index) => (
            <div data-component-id="src/app/SpeakerSection.jsx:80:12" data-component-path="src/app/SpeakerSection.jsx" data-component-line="80" data-component-end-line="101" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20text-center%22%7D" key={index} className="flex flex-col items-center text-center">
              {/* Circle Image */}
              <Image data-component-id="src/app/SpeakerSection.jsx:82:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="82" data-component-end-line="89" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-%5B700px%5D%20h-%5B200px%5D%20object-cover%20w-%5B200px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%22%7D"
                src={speaker.imageSrc}
                alt={speaker.alt}
                width={160}
                height={160}
                className="rounded-[700px] h-[200px] object-cover w-[200px] sm:w-[250px] sm:h-[250px]"
                unoptimized
              />

              {/* Text */}
              <h3 data-component-id="src/app/SpeakerSection.jsx:92:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="92" data-component-end-line="94" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23018440%5D%20text-%5B16px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20mt-3%22%7D" className="text-[#018440] text-[16px] sm:text-[18px] font-semibold mt-3">
                {speaker.name}
              </h3>
              <p data-component-id="src/app/SpeakerSection.jsx:95:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="95" data-component-end-line="97" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%22%7D" className="text-black text-[12px] sm:text-[14px]">
                {speaker.designation}
              </p>
              <p data-component-id="src/app/SpeakerSection.jsx:98:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="98" data-component-end-line="100" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%22%7D" className="text-black text-[12px] sm:text-[14px]">
                {speaker.company}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
